module.exports = __webpack_public_path__ + "static/media/plane-fly.c77846ab.svg";